import { render, staticRenderFns } from "./bank_courier.vue?vue&type=template&id=7cda5ff0&scoped=true&"
import script from "./bank_courier.vue?vue&type=script&lang=js&"
export * from "./bank_courier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cda5ff0",
  null
  
)

export default component.exports